module.exports = __webpack_public_path__ + "img/news.6cbbd78c.svg";